import { render, staticRenderFns } from "./fontain.vue?vue&type=template&id=004c8fa8&lang=true&"
import script from "./fontain.vue?vue&type=script&lang=js&"
export * from "./fontain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports